import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { isString } from 'src/app/data-model';

@Component({
    standalone: false,
    selector: 'bp-bemerkungen',
    templateUrl: './bemerkungen.component.html',
    styleUrls: ['./hl-area.component.css'],
    
})
export class BemerkungenComponent extends HlAreaComponent {
  isString = isString;
}
